import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { LOGIN_URL } from './constants'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: module.hot ? '/front' : '/',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'form' },
    },
    {
      path: '/form',
      name: 'form',
      component: () => import(/* webpackChunkName: "promotion_request_form" */ './views/PromotionRequestForm.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/promotion-change-form/:id-:token',
      name: 'promotion-change-form',
      component: () => import(/* webpackChunkName: "promotion_change_form" */ './views/PromotionChangeForm.vue'),
      props: route => ({
        routeProjectId: route.params.id,
        routeEditToken: route.params.token,
      }),
    },
    {
      path: '/poc-approval-form/:id-:token',
      name: 'poc-approval-form',
      component: () => import(/* webpackChunkName: "poc_approval_form" */ './views/PromotionPocApprovalForm.vue'),
      props: route => ({
        routeProjectId: route.params.id,
        routeApprovalToken: route.params.token,
      }),
    },
  ],
})

router.beforeEach((to, from, next) => {
  const checkAuth = () => {
    const { user } = store.state

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (user === null) {
        location.href = LOGIN_URL
        return
      }

      return next()
    }

    next()
  }

  if (!store.state.initialized) {
    store.dispatch('initialize').then(() => {
      checkAuth()
    })
  } else {
    checkAuth()
  }
})

export default router
